import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'tdesign-react';
import { getCurrentCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';

function NoAuthAlert({ currentCluster, name }) {
  return (
    currentCluster?.clusterAuthType === 'NONE' && (
      <Alert
        style={{ marginTop: 14 }}
        theme='warning'
        message={`新增 ${name} 必须在集群已开启认证时才会生效`}
        close
      />
    )
  );
}

export default connect((state) => ({
  currentCluster: getCurrentCluster(state.kopCluster.allList),
}))(NoAuthAlert);
